import React, { useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import CheckIcon from '@mui/icons-material/Check';

// Small inline "copy a shareable link" icon — a link-glyph sibling of CopyIcon, used next to
// an AWB to copy the public buyer-facing tracking URL (the proship.in tracking app). Stops
// row-click propagation so it's safe inside clickable table rows.
export default function CopyLinkIcon({ url, title = 'Copy tracking link', size = 15 }) {
  const [copied, setCopied] = useState(false);
  if (!url) return null;
  const onCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      navigator.clipboard?.writeText(String(url));
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) { /* clipboard unavailable */ }
  };
  return (
    <Tooltip title={copied ? 'Tracking link copied' : title}>
      <IconButton size="small" onClick={onCopy} sx={{ p: '2px', ml: '2px' }} aria-label="copy tracking link">
        {copied
          ? <CheckIcon sx={{ fontSize: size, color: 'success.main' }} />
          : <LinkIcon sx={{ fontSize: size, color: 'text.secondary' }} />}
      </IconButton>
    </Tooltip>
  );
}
